import apiService from 'apiService';
import React, { useEffect, useState } from 'react';
import { BlockLoading, InlineLoading } from 'view/component/Loading';
import useDataFetching from 'view/hooks/useDataFetching';

const InfoKunjungan = ({ data, getStatusPersyaratan, getPerbaikan, ref_persyaratan }) => {
  const { error, loading, results } = useDataFetching({
    url: '/pirt/penilaian/result/' + data.id,
    method: 'get',
  });

  if (loading) return <BlockLoading loading={loading} />;

  return (
    <table className="table table-flush mt-2">
      <tbody>
        <tr>
          <td>
            <b>ID Pendaftaran Kunjungan</b>
          </td>
          <td>{data.id}</td>
        </tr>
        <tr>
          <td>
            <b>Nama</b>
          </td>
          <td>{`${data.patient.name} ${data.patient.last_name}`}</td>
        </tr>
        <tr>
          <td>
            <b>Alamat</b>
          </td>
          <td>{data.patient.address}</td>
        </tr>
        <tr>
          <td>
            <b>Status</b>
          </td>
          <td>{getStatusPersyaratan(data.ref_persyaratan)}</td>
        </tr>
        {data.jadwal_kunjungan && (
          <tr>
            <td>
              <b>Jadwal Kunjungan</b>
            </td>
            <td>{data.jadwal_kunjungan}</td>
          </tr>
        )}
        {results.data?.result.keterangan && (
          <tr>
            <td>
              <b>Hasil Penilaian</b>
            </td>
            <td>{results.data?.result.keterangan}</td>
          </tr>
        )}
        <tr>
          <td><b>Perbaikan</b></td>
          <td>
            <div>
              <button
                onClick={() => {
                  getPerbaikan(data);
                }}
              >
                cek penilaian
              </button>
            </div>
          </td>
        </tr>

      </tbody>
    </table>
  );
};

const Form1 = ({ setData, setStep, isShow }) => {
  const [detailPendaftaran, setDetailPendaftaran] = useState('');
  const [idPendaftaran, setIdPendaftaran] = useState(1);

  const getDetail = (data) => {
    setData((prevState) => ({
      ...prevState,
      existingPersyaratan: data,
    }));
    setStep(2);
  };

  const getPerbaikan = (data) => {
    setData((prevState) => ({
      ...prevState,
      existingPersyaratan: data,
    }));
    setStep(3);
  };

  const getStatusPersyaratan = (persyaratan) => {
    const verified = persyaratan.filter(
      (value) => value.trx_persyaratan?.verified === 'yes'
    );
    if (verified.length === persyaratan.length) {
      return 'Terverifikasi';
    } else {
      return (
        <div>
          <p>belum terverifikasi</p>
          <button
            onClick={() => {
              getDetail(detailPendaftaran.ref_persyaratan);
            }}
          >
            cek persyaratan
          </button>
        </div>
      );
    }
  };

  const renderInfo = (data) => {
    if (!data) return '';

    switch (data.type) {
      case 'penyuluhan':
        return (
          <table className="table table-flush mt-2">
            <tbody>
              <tr>
                <td>
                  <b>ID Pendaftaran Penyuluhan</b>
                </td>
                <td>{data.id}</td>
              </tr>
              <tr>
                <td>
                  <b>Nama</b>
                </td>
                <td>{`${data.patient.name} ${data.patient.last_name}`}</td>
              </tr>
              <tr>
                <td>
                  <b>Alamat</b>
                </td>
                <td>{data.patient.address}</td>
              </tr>
              <tr>
                <td>
                  <b>Waktu Penyuluhan</b>
                </td>
                <td>
                  {data.jadwal ? `${data.jadwal.date} (${data.jadwal.start_hour} - ${data.jadwal.end_hour})` : ''}

                </td>
              </tr>
              <tr>
                <td>
                  <b>Status</b>
                </td>
                <td>{getStatusPersyaratan(data.ref_persyaratan)}</td>
              </tr>
              {/* <tr>
                <td><b>Perbaikan</b></td>
                <td>
                  <div>
                    <button
                      onClick={() => {
                        getPerbaikan(detailPendaftaran.ref_persyaratan);
                      }}
                    >
                      cek penilaian
          </button>
                  </div>
                </td>
              </tr> */}
            </tbody>
          </table>
        );
      case 'kunjungan':
        return (
          <InfoKunjungan
            data={data}
            getStatusPersyaratan={getStatusPersyaratan}
            ref_persyaratan={detailPendaftaran}
            getPerbaikan={getPerbaikan}
          />
        );
    }
  };

  if (!isShow) return '';

  return (
    <>
      <div className="form-row">
        <div className="form-group col-md-4">
          <input
            className="form-control"
            type="text"
            onChange={(e) => setIdPendaftaran(e.target.value)}
            placeholder="Inputkan No Pendaftaran TRX..."
          />
        </div>
        <div className="form-group col-md-2">
          <button
            className="btn"
            type="button"
            onClick={async (e) => {
              setDetailPendaftaran('');
              const response = await apiService.post(
                '/pirt/pirt_trans/find/' + idPendaftaran,
                {
                  with_patient: 1,
                  with_jadwal: 1,
                  with_persyaratan: 1,
                }
              );
              if (response) {
                setDetailPendaftaran(response.data);
              }
            }}
          >
            Cari
          </button>
        </div>
      </div>
      {renderInfo(detailPendaftaran)}
    </>
  );
};

export default Form1;
